import axios, { AxiosPromise } from 'axios';

import { IColour } from '../../../@types/model/masterData/colour/colour';
import { IColourUpsert } from '../../../@types/model/masterData/colour/colourUpsert';

export default class ColourHttpService {
    public static getColourData() : AxiosPromise<Array<IColour>> {
        return axios.get(`${API_URL}/v1/Colour/GetAllWeb`);
    }

    public static addOrUpdateColour(upsert : IColourUpsert) : AxiosPromise<IColour> {
        return axios.post(`${API_URL}/v1/Colour/PostColour`, upsert);
    }

    public static deleteColour(colourId : number) : AxiosPromise<IColour> {
        return axios.delete(`${API_URL}/v1/Colour/Delete`, {
            params: { colourId },
        });
    }
}
